// extracted by mini-css-extract-plugin
export default {"tagsbox":"Tags_tagsbox__JK89J","tagsitem":"Tags_tagsitem__uxxS5","close":"Tags_close__DGqCV","tagsinput":"Tags_tagsinput__GWGRd"};